import { render, staticRenderFns } from "./BadOG.vue?vue&type=template&id=55532022"
import script from "./BadOG.vue?vue&type=script&lang=js"
export * from "./BadOG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports